import FaqEngenPrimax from "./FaqEngenPrimax";

export default FaqEngenPrimax;
